
(() => {
  const descriptions = {
    1: 'Generation 1 combines the selected face colour with distinctly darker black recessed channels. The stronger contrast gives the fluted profile a bolder, more architectural appearance.',
    2: 'Generation 2 carries the selected colour through the recessed channels as a full-colour wrap. The result is cleaner, softer and more seamless across the full elevation.'
  };
  document.querySelectorAll('[data-vigo-cladding-visualiser]').forEach(root => {
    const jsonNode = root.querySelector('[data-vis-data]');
    if (!jsonNode) return;
    let data;
    try { data = JSON.parse(jsonNode.textContent); } catch(e) { return; }
    const order = Object.keys(data);
    const gen1 = root.querySelector('[data-vis-gen1]');
    const gen2 = root.querySelector('[data-vis-gen2]');
    const hero = root.querySelector('[data-vis-hero]');
    const room = root.querySelector('[data-vis-room]');
    const product = root.querySelector('[data-vis-product]');
    const colour = root.querySelector('[data-vis-colour]');
    const generation = root.querySelector('[data-vis-generation]');
    const detailColour = root.querySelector('[data-vis-detail-colour]');
    const badge = root.querySelector('[data-vis-badge]');
    const desc = root.querySelector('[data-vis-description]');
    const channel = root.querySelector('[data-vis-channel]');
    const width = root.querySelector('[data-vis-width]');
    const depth = root.querySelector('[data-vis-depth]');
    const length = root.querySelector('[data-vis-length]');
    const link = root.querySelector('[data-vis-link]');

    const select = (key) => {
      const item = data[key]; if (!item) return;
      hero.classList.add('is-loading');
      const pre = new Image();
      pre.onload = () => { room.src = item.room; requestAnimationFrame(() => hero.classList.remove('is-loading')); };
      pre.src = item.room;
      product.src = item.product;
      room.alt = `${item.colour} Vigo WPC wall cladding, Generation ${item.gen}, visualised on a garden room`;
      product.alt = `${item.colour} Vigo WPC wall cladding sample, Generation ${item.gen}`;
      colour.textContent = item.colour;
      generation.textContent = item.gen === 1 ? 'GEN 1 — BLACK CONTRAST CHANNELS' : 'GEN 2 — FULL COLOUR WRAP';
      detailColour.textContent = item.colour;
      badge.textContent = item.gen === 1 ? 'GEN 1 — BLACK CONTRAST CHANNELS' : 'GEN 2 — FULL COLOUR WRAP';
      desc.textContent = descriptions[item.gen];
      channel.textContent = item.gen === 1 ? 'BLACK' : 'FULL WRAP';
      if (width) width.textContent = item.width || '219mm';
      if (depth) depth.textContent = item.depth || '26mm';
      if (length) length.textContent = item.length || '3m';
      if (link && item.url) { link.href = item.url; link.setAttribute('aria-label', `View ${item.colour} Generation ${item.gen} wall cladding product`); }
      root.querySelectorAll('[data-vis-key]').forEach(btn => { const active = btn.dataset.visKey === key; btn.classList.toggle('is-active', active); btn.setAttribute('aria-pressed', active ? 'true' : 'false'); });
    };

    order.forEach(key => {
      const item = data[key];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vigo-cladding-vis__finish';
      btn.dataset.visKey = key;
      btn.setAttribute('aria-label', `${item.colour} Vigo wall cladding, Generation ${item.gen}`);
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = `<span class="vigo-cladding-vis__tick" aria-hidden="true"></span><img src="${item.product}" alt="${item.colour} wall cladding sample" loading="lazy"><span class="vigo-cladding-vis__finish-label">${item.colour}</span>`;
      btn.addEventListener('click', () => select(key));
      (item.gen === 1 ? gen1 : gen2).appendChild(btn);
    });

    const def = root.dataset.defaultKey && data[root.dataset.defaultKey] ? root.dataset.defaultKey : 'teak-gen1';
    select(def);
  });
})();
